import React from 'react'

import whatsapp from '../../../../../images/whatsapp.png'
import telegram from '../../../../../images/telegram.png'
import qrWhatsapp01 from '../../../../../images/qr-whatsapp-01.png'
import qrTelegram01 from '../../../../../images/qr-telegram-01.png'

export const FooterContact2: React.FC = () => {
    return (
        <>
            <div className="text-[20px] text-[#FFFFFF] font-bold text-left">
                Напишите нам
            </div>
            <div className="text-[16px] text-left space-y-3">
                <p className="text-[#6A6A6A] dark:text-[#8A8A8A]">WhatsApp:</p>
                <div className="flex flex-row gap-5">
                    <p>
                        <img
                            width={40}
                            height={40}
                            src={whatsapp}
                            alt="Логотип"
                        />
                    </p>
                    <p>
                        <img
                            width={80}
                            height={80}
                            src={qrWhatsapp01}
                            alt="QR"
                        />
                    </p>
                </div>
                <p className="text-[#6A6A6A] dark:text-[#8A8A8A]">Telegram:</p>
                <div className="flex flex-row gap-5">
                    <p>
                        <img
                            width={40}
                            height={40}
                            src={telegram}
                            alt="Логотип"
                        />
                    </p>
                    <p>
                        <img
                            width={80}
                            height={80}
                            src={qrTelegram01}
                            alt="QR"
                        />
                    </p>
                </div>
            </div>
        </>
    )
}
